// extracted by mini-css-extract-plugin
export default {"app-footer":"_5DtsSfkG","no-auth-footer":"_5DrPBrPU"};